import React, { useState } from 'react';
import { Modal, Button, Form, TextArea, Message } from 'semantic-ui-react';

const WithdrawalModal = ({ 
    open, 
    onClose, 
    onSubmit, 
    isSubmitting = false,
    requestData = null 
}) => {
    const [withdrawalReason, setWithdrawalReason] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = () => {
        if (!withdrawalReason.trim()) {
            setError('Please provide a reason for withdrawal');
            return;
        }

        if (withdrawalReason.trim().length < 10) {
            setError('Please provide a more detailed reason (at least 10 characters)');
            return;
        }

        setError('');
        onSubmit(withdrawalReason.trim());
    };

    const handleClose = () => {
        setWithdrawalReason('');
        setError('');
        onClose();
    };

    return (
        <Modal
            open={open}
            onClose={handleClose}
            size="small"
            closeOnDimmerClick={!isSubmitting}
            closeOnEscape={!isSubmitting}
        >
            <Modal.Header>
                Withdraw Request
                {requestData && (
                    <div style={{ fontSize: '0.8em', fontWeight: 'normal', marginTop: '4px', color: '#666' }}>
                        Request ID: {requestData.id}
                    </div>
                )}
            </Modal.Header>
            
            <Modal.Content>
                <Message warning>
                    <Message.Header>Are you sure you want to withdraw this request?</Message.Header>
                    <p>This action will change the request status to "Withdrawn" and cannot be undone. Please provide a reason for withdrawal.</p>
                </Message>

                <Form>
                    <Form.Field required>
                        <label>Reason for Withdrawal</label>
                        <TextArea
                            placeholder="Please explain why you want to withdraw this request..."
                            value={withdrawalReason}
                            onChange={(e) => setWithdrawalReason(e.target.value)}
                            rows={4}
                            disabled={isSubmitting}
                        />
                    </Form.Field>
                    
                    {error && (
                        <Message negative>
                            {error}
                        </Message>
                    )}
                </Form>
            </Modal.Content>

            <Modal.Actions>
                <Button 
                    onClick={handleClose}
                    disabled={isSubmitting}
                >
                    Cancel
                </Button>
                <Button 
                    negative
                    loading={isSubmitting}
                    disabled={isSubmitting || !withdrawalReason.trim()}
                    onClick={handleSubmit}
                >
                    Withdraw Request
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default WithdrawalModal;
